import createStaticRef from '../../../../Core/Helpers/createStaticRef'

const moduleProps = createStaticRef()

export default moduleProps
